import { SECOND } from 'lib/time';

export function minmax(current: number, max = 1, min = 0): number {
    return Math.max(min, Math.min(max, current));
}

export function round(value: number): number {
    return Math.round((value + Number.EPSILON) * SECOND) / SECOND;
}
